import apiServices from "../apiServices";
import { validateOrThrowApiResponse } from "../response-validator";

type LocalStorageUser = {
    id?: string;
    name?: string;
};

const teacherAPI = {

    createTeacher(uuid: string, name: string) {
        return apiServices
            .post(
                `/api/teacher`,
                { uuid, name },
                {
                    headers: {
                        Accept: "application/json",
                    },
                },
            )
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error createTeacher:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    },

    createTeacherFromLocalStorage() {
        if (typeof window === "undefined") {
            return Promise.resolve({
                status: "failed",
                errMessage: "createTeacherFromLocalStorage can only run in browser",
            });
        }

        try {
            const rawUser = localStorage.getItem("user");
            if (!rawUser) {
                return Promise.resolve({
                    status: "failed",
                    errMessage: "No user data in localStorage",
                });
            }

            const parsedUser = JSON.parse(rawUser) as LocalStorageUser;
            const uuid = parsedUser?.id?.trim();
            const name = parsedUser?.name?.trim();

            if (!uuid || !name) {
                return Promise.resolve({
                    status: "failed",
                    errMessage: "Missing user.id or user.name in localStorage",
                });
            }

            return this.createTeacher(uuid, name);
        } catch (err) {
            console.log("Error createTeacherFromLocalStorage:", err);
            return Promise.resolve({
                status: "failed",
                errMessage: (err as Error)?.message || err,
                error: err,
            });
        }
    },

    checkUser() {
        return apiServices
            .get(`/api/teacher/check-user`, {
                headers: {
                    Accept: "application/json",
                },
            })
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error checkUser:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    },

    createUser(name?: string) {
        return apiServices
            .post(
                `/api/teacher/create-user`,
                { name: name ?? "" },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                },
            )
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error createUser:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    },

    countTeacher() {
        return apiServices
            .get(`/api/teacher/count`, {
                headers: {
                    Accept: "application/json",
                },
            })
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error countTeacher:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    },

    teacherCountCreateGameRanking() {
        return apiServices
            .get(`/api/teacher/ranking/create-game`, {
                headers: {
                    Accept: "application/json",
                },
            })
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error teacherCountCreateGameRanking:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    },

}

export default teacherAPI;